/**
 * Lodash <https://lodash.com/>
 * Copyright JS Foundation and other contributors <https://js.foundation/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
function debounce(func, wait) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = Date.now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(Date.now());
  }

  function debounced() {
    var time = Date.now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

$( document ).ready(function() {

    $('.date').datetimepicker({
        format: 'MM-DD-YY'
    });


    function add_post_values(name, value) {
        $('<input>', {
            type: 'hidden',
            name: name,
            value: value
        }).appendTo('#nav_form');
    }
    svg4everybody();

    $('body').tooltip({
        selector: '[data-toggle="tooltip"]'
    });

    if ($('#content-div').outerHeight() < $(window).outerHeight()){
        var min_height = $(window).outerHeight()-$('#main-navbar').outerHeight()-($('#footer').outerHeight()*1.5);
        $('#content-div').css('min-height', min_height + 'px');
    }

    // Only load vehicle images once they're in view
    var lazyImages = $('.vehicle-image');
    if (lazyImages.length > 0) {
        if ("IntersectionObserver" in window) {
            var lazyImageObserver = new IntersectionObserver(function(entries, observer) {
                entries.forEach(function(entry) {
                    if (entry.isIntersecting) {
                        var lazyImage = entry.target;
                        lazyImage.src = lazyImage.dataset.src;
                        lazyImageObserver.unobserve(lazyImage);
                    }
                });
            });

            lazyImages.each(function(i, e) {
                lazyImageObserver.observe(e);
            });
        } else {
            // If the browser doesn't support IntersectionObserver,
            // then just do the replacement right away
            lazyImages.each(function(i, e) {
                e.src = e.dataset.src;
            });
        }
    }
});


function mark_comments_as_read(user_id, inspection_id){

    $.ajax({
        method: "POST",
        url: "/inspections/mark-comments-read",
        dataType:'text',
        data: JSON.stringify({
            'user_id': user_id,
            'inspection_id': inspection_id
        })
    }).done(function (data) {
        data = JSON.parse(data);
        read_counter = data['read'];
        counter_ele = $('#dashboard_comments_counter');
        current_count = parseInt(counter_ele.html());
        counter_ele.html((current_count-read_counter));
    });
}

    // ajax call to server that updates the inspection status to the new one
    // for each of the inspection ids that is part of the array
    function AddComment(inspection_id, comment_to_add, username, callback) {

        console.log('adding comment to inspection_id=' + inspection_id + ', comment=' + comment_to_add + ', username=' + username);

        // for each value in the array
        // update the status
        var result = true;

        var json_msg = {
            id: inspection_id,
            comment: comment_to_add,
            user: username
        };

        $.ajax({
            method: "POST",
            url: "/inspections/add-comment",
            data: JSON.stringify(json_msg)
        }).done(function (msg) {
            result = true;
            console.log('successful ajax response: ' + msg);

            var options = {
                text: "Successfully added comment", // text of the snackbar
                duration: 2000, // time in milliseconds after the snackbar autohides, 0 is disabled
                showAction: false                
            };

            Snackbar.show(options);
            callback(msg);

        });

        return result;

    }

    // ajax call that updates the inspection
    function UpdateInspection(json_msg) {

      /*
        used to validate and send JSON to the update function
        example msg
        {"inspection_id":"abb53b2a-7e82-448e-8509-694696730ca6","inspection_status_code":"REVIEW","approval_status_code":"ACCEPTABLE","reason_code":"test","username":"jay"}
      */

        console.log('updating inspection inspection_id=' + JSON.stringify(json_msg));

        // for each value in the array
        // update the status
        var result = true;

        $.ajax({
            method: "POST",
            url: "/inspections/status-edit",
            data: JSON.stringify(json_msg)
        }).done(function (msg) {
            result = true;
            console.log('successful ajax response: ' + msg);

            if ('id' in msg) {
                if (msg['id'] != 0) {
                    var options = {
                        text: "Successfully updated inspection ", // text of the snackbar
                        duration: 2000, // time in milliseconds after the snackbar autohides, 0 is disabled
                        showAction: false                        
                    };

                } else {
                    var options = {
                        text: "An error occured during update: " + msg['message'], // text of the snackbar
                        duration: 5000, // time in milliseconds after the snackbar autohides, 0 is disabled
                        showAction: false                        
                    };
                }
            }

            Snackbar.show(options);
            location.reload();

        });

        return result;

    }

function getCookie(name) {
    var cookieValue = null;
    if (document.cookie && document.cookie !== '') {
        var cookies = document.cookie.split(';');
        for (var i = 0; i < cookies.length; i++) {
            var cookie = jQuery.trim(cookies[i]);
            // Does this cookie string begin with the name we want?
            if (cookie.substring(0, name.length + 1) === (name + '=')) {
                cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
                break;
            }
        }
    }
    return cookieValue;
}

var csrftoken = getCookie('csrftoken');

function send_request_to_download_file(request_type, url, data) {
    $("body").css("cursor", "progress");
    /*
        The reason we are using XMLHttpRequest is that Jquery ajax will not download the file, but a direct XMLHttpRequest will
     */
    //Creating a clickable hyperlink to download file from post request
    xhttp = new XMLHttpRequest();
    xhttp.onload = function (e) {
        $("body").css("cursor", "default");
        var a;
        if (xhttp.readyState === 4 && xhttp.status === 200) {
            // Trick for making downloadable link
            a = document.createElement('a');
            a.href = window.URL.createObjectURL(xhttp.response);
            // Give filename you wish to download
            a.download = "condition_report.pdf";
            a.style.display = 'none';
            document.body.appendChild(a);
            a.click();
        } else {
            $('#notification_modal_body').html('There was an error downloading the file.');
            $('#notification_modal').modal();
        }
    };

    //Send to views endpoint if requested with Original CR else send request to AiM CR
    if(data["original_cr_url"]){
        data["aimcr_url"] = url;
        xhttp.open("POST", "/inspections/fmcc-merged-cr");
    }
    else{
        xhttp.open(request_type, url);
    }
    xhttp.setRequestHeader("Content-Type", "application/json");
    xhttp.setRequestHeader("X-CSRFToken", csrftoken);
    // You should set responseType as blob for binary responses
    xhttp.responseType = 'blob';
    xhttp.send(JSON.stringify(data));
}